<template>
  <div class="dropdown">
    <a href="#" class="d-flex align-items-center text-white text-decoration-none dropdown-toggle" id="dropdownUser1" data-bs-toggle="dropdown">

      <i class="bi bi-person-circle"/>&nbsp;&nbsp;&nbsp;

      <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{ user?.name || user?.login }}</span>

    </a>
    <ul class="dropdown-menu dropdown-menu-dark text-small shadow">
      <li><a class="dropdown-item" href="#" @click.prevent="$router.push({name:'profile'})">Профиль</a></li>
      <li><a class="dropdown-item" href="#" @click.prevent="logout">Выйти</a></li>
    </ul>
  </div>

</template>

<script>


import {auth} from "@/state/auth";

export default {

  computed: {
    user() {
      return auth.user;
    }
  },

  methods: {
    logout() {
      auth.logout();
    },
  }


}
</script>

